import {WorkrequestDetailsBase} from '../../shared/data-objects/workrequest-details-base';

export class WorkrequestPfiDetails extends WorkrequestDetailsBase {
  //nextWorkingDayrequired: boolean;
  within5BusinessDaysrequired: boolean;
  singleSupplyPointrequired: boolean;
  alternateSupplyPointrequired: boolean;
  requiredWorkRequestPfiPercentPressure: boolean;
  planOfSubdivisionNumber: string;
  lotNumber: string;
  unitNumber: string;
  streetNumber: string;
  streetName: string;
  streetType: number;
  streetSuffixType: number;
  suburb: string;
  postCode: string;

  constructor() {
    super();
    //this.nextWorkingDayrequired = false;
    this.within5BusinessDaysrequired = true;
    this.singleSupplyPointrequired = false;
    this.alternateSupplyPointrequired = false;
    this.requiredWorkRequestPfiPercentPressure = false;
    this.unitNumber = '';
    this.streetNumber = '';
    this.streetName = '';
    this.streetType = 0;
    this.streetSuffixType = 0;
    this.suburb = '';
    this.postCode = '';
    this.planOfSubdivisionNumber = '';
    this.lotNumber= '';
  }

  toUpperCase() {
  }

  setDescriptionOfWork() {
    if (this.requiredWorkRequestPfiPercentPressure) {
      const dow = this.descriptionOfWork;
      this.descriptionOfWork = dow;
    } else {
      this.descriptionOfWork = '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/pfi-form/workrequest-pfi-details.ts